export default "__VITE_ASSET__CHzbj_ww__"